import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=3055ba0f&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=3055ba0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055ba0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3055ba0f')) {
      api.createRecord('3055ba0f', component.options)
    } else {
      api.reload('3055ba0f', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=3055ba0f&scoped=true&", function () {
      api.rerender('3055ba0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Ir3XrvhaBM/JS/comp/PopupDialog.vue"
export default component.exports